<template>
  <!-- Table -->
  <div class="row">
    <div class="col-sm-12">
      <div class="card-table">
        <div class="card-body">
          <div class="table-responsive">
            <a-table
              class="stripped table-hover"
              :columns="columns"
              :data-source="customer_estimates"
            >
              <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'index'">
                  <span>{{ index + 1 }}</span>
                </template>
                <template v-else-if="column.key === 'estimate_id'">
                  <router-link
                    style="color: #878a99"
                    :to="`/view-estimate/` + record.id"
                  >
                    {{ record.estimate_id }}
                  </router-link>
                </template>
                <template v-else-if="column.key === 'customer'">
                  {{ record.customer.name }}
                </template>
                <template v-else-if="column.key === 'date'">
                  {{ formatted(record.date) }}
                </template>
                <template v-else-if="column.key === 'due_date'">
                  {{ formatted(record.due_date) }}
                </template>
                <template v-else-if="column.key === 'total_amount'">
                  <span
                    >{{ record?.currency?.slice(0, 3) }}
                    {{ addCurrencyComma(record.total_amount) }}</span
                  >
                </template>
                <template v-else-if="column.key === 'status'">
                  <span
                    class="badge bg-success-light text-success-light text-capitalize"
                    v-if="
                      record.status === 'paid' ||
                      record.status === 'refunded' ||
                      record.status === 'sent' ||
                      record.status === 'viewed' ||
                      record.status === 'accepted'
                    "
                    >{{ record.status }}</span
                  >
                  <span
                    class="badge bg-warning-light text-warning-light text-capitalize"
                    v-else-if="
                      record.status === 'draft' ||
                      record.status === 'pending' ||
                      record.status === 'unpaid' ||
                      record.status === 'recurring'
                    "
                    >{{ record.status }}</span
                  >
                  <span
                    class="badge bg-warning-light text-warning-light text-capitalize"
                    v-else-if="record.status === 'partially_paid'"
                    >Partially paid</span
                  >
                  <span
                    class="badge bg-danger-light text-capitalize"
                    v-else-if="
                      record.status === 'expired' ||
                      record.status === 'rejected' ||
                      record.status === 'overdue'
                    "
                    >{{ record.status }}</span
                  >
                </template>
                <template v-if="column.key === 'action'">
                  <div class="d-flex align-items-center justify-content-start">
                    <div class="dropdown dropdown-action">
                      <a
                        class="btn-action-icon"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        >Action</a
                      >
                      <div class="dropdown-menu dropdown-menu-end">
                        <ul>
                          <li>
                            <router-link
                              class="dropdown-item"
                              :to="`/view-estimate/` + record.id"
                              ><i class="far fa-eye me-2"></i>View</router-link
                            >
                          </li>
                          <li>
                            <router-link
                              class="dropdown-item"
                              :to="`/edit-estimate/` + record.id"
                              ><i class="far fa-edit me-2"></i>Edit</router-link
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'send')"
                              ><i class="fa fa-bolt text-success me-2"></i
                              >Send</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'delete')"
                              ><i class="far fa-trash-alt text-danger me-2"></i
                              >Delete</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'duplicate')"
                              ><i class="far fa-clone me-2"></i>Duplicate</a
                            >
                          </li>
                          <li
                            v-if="
                              record.status == 'sent' ||
                              record.status == 'viewed' ||
                              record.status == 'draft'
                            "
                          >
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'accept')"
                              ><i
                                class="fa fa-check-circle text-success me-2"
                              ></i
                              >Mark as Accepted</a
                            >
                          </li>
                          <li
                            v-if="
                              record.status == 'sent' ||
                              record.status == 'viewed' ||
                              record.status == 'draft'
                            "
                          >
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'reject')"
                              ><i
                                class="fa fa-times-circle text-danger me-2"
                              ></i
                              >Mark as Rejected</a
                            >
                          </li>
                          <li>
                            <a
                              class="dropdown-item"
                              @click="openModal(record, 'convert')"
                              ><i class="feather feather-repeat me-2"></i
                              >Convert to invoice</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Table -->
</template>

<script setup>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { formatted } from "@/assets/composables/date";
import { addCurrencyComma } from "@/assets/composables/currency";

const store = useStore();
const route = useRoute();
const emit = defineEmits(["openModal"]);
const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Estimate ID",
    key: "estimate_id",
    sorter: true,
  },
  {
    title: "Customer",
    key: "customer",
    sorter: true,
  },
  {
    title: "Date Created",
    key: "date",
    sorter: true,
  },
  {
    title: "Expiry Date",
    key: "due_date",
    sorter: true,
  },
  {
    title: "Amount",
    key: "total_amount",
    sorter: true,
  },
  {
    title: "Status",
    key: "status",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const openModal = (record, name) => {
  let data = {
    data: record,
    name: name,
  };
  emit("openModal", data);
};

const getCustomerHistory = () => {
  store.dispatch("customer/getCustomerHistory", route.params.id);
};

const customer_estimates = computed(() => {
  return store.getters["customer/customer_history"].estimates;
});

onMounted(() => {
  getCustomerHistory();
});
</script>
